import baseAxios, { AxiosRequestConfig } from "axios";

let instance = baseAxios.create();

export function api() {
  return instance;
}

export function setupApi(config: AxiosRequestConfig) {
  instance = baseAxios.create(config);

  return instance;
}

export function getApiConfig() {
  return { ...instance.defaults };
}

export const setAuthToken = (args: { access_token: string }) => {
  instance.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${args.access_token}`;
};

export const axios = {
  setAuthToken,
  api,
  ...baseAxios,
};
